// src/hooks/useMarkNotificationAsRead.ts
import useNotificationStore from 'src/store/api/useNotificationStore';

export const useMarkNotificationAsRead = () => {
  const { successMessage, isLoading, error, markNotificationAsRead } = useNotificationStore();

  return { successMessage, isLoading, error, markNotificationAsRead };
};
